if (!customElements.get('product-card')) {
  class ComponentProductCard extends HTMLElement {
    constructor() {
      super()
      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      this.swatches = this.querySelector('.inline-swatch-group')
      
      // Use event delegation for better performance
      if(this.quickViewBtn)
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this))
      
      if(this.swatches) {
        // Use event delegation instead of individual listeners
        this.swatches.addEventListener('change', (e) => {
          if (e.target.matches('input')) {
            this.onSwatchChange(e);
          }
        });
      }
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var quickviewTemplate = 'product'
      var qvUrl = this.quickViewBtn.dataset.url + '&view=' + quickviewTemplate;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
          setTimeout(function(){
            checkIfActiveSubs();
            checkOptinState();
          }, 400);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onSwatchChange(e) {
      // Use requestAnimationFrame to batch DOM updates
      requestAnimationFrame(() => {
        var checkedOption = e ? e.target : this.querySelector('.inline-swatch-group input:checked')
        var variantImg = checkedOption.dataset.variantImg
        var variantUrl = checkedOption.dataset.variantUrl
        var priceFinal = checkedOption.dataset.priceFinal
        var priceCompare = checkedOption.dataset.priceCompare

        // Batch DOM updates to reduce reflows
        const fragment = document.createDocumentFragment();
        
        this.querySelectorAll('.product-card-url').forEach(function(e){
          e.setAttribute('href', variantUrl)
        });
        if (this.quickViewBtn)
          this.quickViewBtn.setAttribute('data-url', variantUrl)
        
        const finalPriceEl = this.querySelector('.final');
        if (finalPriceEl) finalPriceEl.innerHTML = priceFinal;
        
        const fromEl = this.querySelector('.from');
        if(fromEl) {
          fromEl.style.display = "none"
        }
        
        const compareEl = this.querySelector('.compare');
        if(priceCompare) {
          compareEl.innerHTML = priceCompare
          compareEl.style.display = "block"
        } else {
          compareEl.style.display = "none"
        }
        
        if(variantImg) {
          const imgEl = this.querySelector('.img.main');
          if (imgEl) imgEl.setAttribute('srcset', variantImg)
        }
      });
    }
  }
  customElements.define('product-card', ComponentProductCard);
}